import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';

import { useModal } from 'components/Modal/Modal.hooks';
import { SuccessModalProps } from 'components/Modal/Modal.types';

import styles from 'components/Modal/ModalTypes/SuccessModal/SuccessModal.module.scss';

const cn = classNames.bind(styles);

const SuccessModal: FC<SuccessModalProps> = ({
  heading,
  paragraphs,
  redirectButtonText,
  redirectButtonUrl,
}): ReactElement => {
  const { closeModal } = useModal();

  return (
    <div className={cn('success-modal')}>

      {/* <div className={cn('success-modal__icon-container')}>
        {IconSuccess}
      </div> */}

      <h4 className={cn('success-modal__heading')}>
        {heading}
      </h4>

      <div className={cn('success-modal__description')}>
        {paragraphs.map((paragraph, index) => {
          return (
            <p
              className={cn('success-modal__description-paragraph')}
              key={index}
            >
              {paragraph}
            </p>
          )
        })}
      </div>

      <div className={cn('success-modal__buttons')}>
        <Link
          className={cn('success-modal__button-redirect')}
          href={redirectButtonUrl}
          onClick={closeModal}
        >
          {redirectButtonText}
        </Link>
      </div>
    </div>
  );
};

export { SuccessModal };